// extracted by mini-css-extract-plugin
module.exports = {"list-item":"Assortments_list-item__29xDh","active":"Assortments_active__2wv5W"};